module.exports = __webpack_public_path__ + "static/media/predicting-user-conversions.94b19489.jpeg";